import { render, staticRenderFns } from "./ResumenTiempos.vue?vue&type=template&id=256c219c&scoped=true&"
import script from "./ResumenTiempos.vue?vue&type=script&lang=ts&"
export * from "./ResumenTiempos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256c219c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('256c219c', component.options)
    } else {
      api.reload('256c219c', component.options)
    }
    module.hot.accept("./ResumenTiempos.vue?vue&type=template&id=256c219c&scoped=true&", function () {
      api.rerender('256c219c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/ProgramacionInforme/TiposdeInformes/TipoResumenTiempos/ResumenTiempos.vue"
export default component.exports